import { render, staticRenderFns } from "./PermissionsEventsForm.vue?vue&type=template&id=1bd1a002&scoped=true&"
import script from "./PermissionsEventsForm.vue?vue&type=script&lang=js&"
export * from "./PermissionsEventsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd1a002",
  null
  
)

export default component.exports